import streamProviderFromFetcher from 'rlink-data-connector/streams/streamProviderFromFetcher';
import clientFetch from 'rlink-data-connector/fetching/clientFetch';

export default function clientRequestStream (config) {
  return streamProviderFromFetcher(clientFetch(config));
}



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/streams/clientRequestStream.js